import React, { useState, useEffect } from 'react';
import { Container, Spinner } from 'react-bootstrap';
import { fetchAppliedRoleListApi } from '../../../services/api';
import { TalentAuditionCard } from '../../../components/dashboard/TalentAuditionCard';
import './MyApplicationRow.css';

const MyApplicationRow = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('All');

  const filters = ['All', 'Pending', 'Selected', 'Rejected', 'Resubmit'];

  useEffect(() => {
    fetchAppliedRoleListApi().then(({ data }) => {
      const list = data?.data || [];
      setData(list);
      setFilteredData(list);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleFilter = (status) => {
    setActiveFilter(status);
    if (status === 'All') {
      setFilteredData(data);
    } else {
      setFilteredData(data.filter(item => 
        (item.result || 'Pending').toLowerCase() === status.toLowerCase()
      ));
    }
  };

  if (loading) return <div className="text-center py-5"><Spinner variant="danger" /></div>;

  return (
    <Container className="custom-container ">
      <h2 className="text-center mb-4">Audition <span className="text-danger">Status</span></h2>
      
      {/* Filter Buttons */}
      {/* <div className="d-flex justify-content-center gap-2 mb-4 filter-container-status"> */}
      <div className="filter-scroll-wrapper">
        <div className="filter-scroll">
        {filters.map(f => (
          <button 
            key={f} 
            onClick={() => handleFilter(f)}
            className={`btn ${activeFilter === f ? 'btn-filter-active' : 'btn-filter-inactive'} rounded-pill px-4 mx-1`}
          >
            {f}
          </button>
        ))}
        </div>
      </div>

      {/* Grid Display */}
      {/* <div className="row g-4">
        {filteredData.length > 0 ? (
          filteredData.map((item) => (
            // <div className="col-md-3" key={item.roleApplicationId}>
            <div className="col-6 col-md-3" key={item.roleApplicationId}>
              <TalentAuditionCard audition={item} />
            </div>
          ))
        ) : (
          <p className="text-center">No auditions found for "{activeFilter}"</p>
        )}
      </div> */}

       {/* <div className="row audition-grid"> */}
       <div className='audition-grid'>
        {filteredData.length > 0 ? (
          filteredData.map((item) => (
            // <div
            //   className="audition-col col-6 col-md-3"
            //   key={item.roleApplicationId}
            // >
                <div className="audition-col" key={item.roleApplicationId}>
              <TalentAuditionCard audition={item} />
            </div>
          ))
        ) : (
          <p className="no-data text-center">
            No auditions found for "{activeFilter}"
          </p>
        )}
      </div>


    </Container>
  );
};

export default MyApplicationRow;